// Copyright (c) Bentley Systems
import { DocumentVersion } from "./document-version";

export class ArchiveDocument {
  public id: number;
  public nodeId: number;
  public name: string;
  public desc?: string;
  public created: Date;
  public version: DocumentVersion;

  constructor(
    id: number,
    nodeId: number,
    name: string,
    created: Date,
    version: DocumentVersion,
    desc?: string,
  ) {
    this.id = id;
    this.nodeId = nodeId;
    this.name = name;
    if (desc !== undefined) {
      this.desc = desc;
    }
    this.created = created;
    this.version = version;
  }
}
